import type { SuggestedAction } from "src/pages/ad-studio/insights/ad-suggested-actions";
import {
  AdSuggestedActionsRow,
  AdSuggestedActionsRowSkeleton,
} from "src/pages/ad-studio/insights/ad-suggested-actions-row";
import type { SuggestedActionsState } from "src/pages/ad-studio/insights/use-suggested-actions";

type SuggestedActionsSectionParentAction = {
  kind: "SuggestedActionsSectionParentAction/selected";
  action: SuggestedAction;
};

type SuggestedActionsSectionProps = {
  suggestions: SuggestedActionsState;
  performParentAction: (action: SuggestedActionsSectionParentAction) => void;
};

export const SuggestedActionsSection = ({
  suggestions,
  performParentAction,
}: SuggestedActionsSectionProps) => {
  switch (suggestions.status) {
    case "loading": {
      return <AdSuggestedActionsRowSkeleton />;
    }
    case "loaded": {
      return (
        <AdSuggestedActionsRow
          actions={[...suggestions.actions]}
          onSelect={(action) =>
            performParentAction({
              kind: "SuggestedActionsSectionParentAction/selected",
              action,
            })
          }
        />
      );
    }
    default: {
      return suggestions satisfies never;
    }
  }
};
